import { WALLET, WALLET_SUCCESS, WALLET_FAIL, CLEAR_REQUEST } from '../actionTypes';

const initialState = {
    loading: false,
    wallet: {
        actual_balance: 0,
        ledger_balance: 0.00,
        lifetime_commision: 0.00,
        lifetime_commision_verified: 0.00,
        lifetime_sales_count: 0,
        lifetime_sales_count_verified: 0,
        lifetime_sales_value: 0.00,
        lifetime_sales_value_verified: 0.00,
        payout_count: 0,
        payout_count_verified: 0,
        lifetime_payout: 0,
        lifetime_payout_verified: 0,
        withdrawal_amount: 0,
    }
};

export const walletReducer = (state = initialState, action) => {
    switch (action.type) {
        case WALLET:
            return { ...state, loading: true };
        case WALLET_SUCCESS:
            return { ...state, loading: false, wallet: action.payload };
        case WALLET_FAIL:
            return { ...state, loading: false, error: action.payload };
        case CLEAR_REQUEST:
            return {};
        default:
            return state;
    }
};
